import React from 'react';
import translate from '@/utils/translate';
import {formatSmartAbbreviation} from '@/components/gig-cards/utils';
import type {GigBriefData} from '../shell/informationTypes';
import {lookupNetworkName} from '../shell/networkName';
import BriefSection from './BriefSection';
import styles from './BriefBlocks.module.scss';

interface EligibilityCardProps {
  eligibility: GigBriefData['eligibility'];
}

/** Hidden entirely when the campaign has no network, matching Ember. */
function EligibilityCard({eligibility}: EligibilityCardProps) {
  const {network, unlocksAt} = eligibility;
  if (!network) {
    return null;
  }

  return (
    <BriefSection
      testID="brief-eligibility"
      title={translate('Am I eligible?')}
      subtitle={translate('You must meet these requirements:')}
    >
      <div className={styles.requirement} data-testid="brief-follower-count">
        <span className={styles.requirementLabel}>
          {lookupNetworkName(network)}
        </span>
        <span>
          {translate('{unlocksAt}+ followers', {
            unlocksAt: formatSmartAbbreviation(unlocksAt ?? 0),
          })}
        </span>
      </div>
    </BriefSection>
  );
}

export default EligibilityCard;
